import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';

const useHttpTransferOwnership = (organizationId: string) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);

    const exec = (newOwnerUserSub: string) => {
        const { exec, abort } = organizationApi.transferOwnership({
            params: { organizationId },
            body: { newOwnerUserSub },
            onSuccess: () => {},
        });

        exec();
        return abort;
    };

    return { exec };
};

export default useHttpTransferOwnership;
